// app/javascript/functions/toggle_all_sections.js

// Import Bootstrap to use its Collapse component
import * as bootstrap from 'bootstrap';

export function toggleAllSections() {
    var allSections = document.querySelectorAll('.multi-collapse');
    allSections.forEach(function(section) {
        var isExpanded = section.classList.contains('show');
        if (isExpanded) {
            new bootstrap.Collapse(section, { toggle: false }).hide();
        } else {
            new bootstrap.Collapse(section, { toggle: false }).show();
        }
    });
}
